import useProject from './useProject';

export const useFile = (fileId) => {
  const { get } = useProject();
  return get(fileId);
};

export default useFile;
